export default __webpack_public_path__ + "static/g-03-f3001b91e7251c1ee0bcd068d7295b30.png";